import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withFormik } from 'formik';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import dayjs from 'dayjs'
//import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
//import 'react-datepicker/dist/react-datepicker.css'
//import DatePicker from 'react-datepicker';

const FormStyled = styled.form`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px;
  position: relative;
`;
const TextFieldStyled = styled(TextField)`
  margin: 0 4px;
`;
const FormControlStyled = styled(FormControl)`
  margin: 0 4px;
  min-width: 200px;
`;
const ButtonContainer = styled.div`
  margin-top: 12px;
`;

const FormOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color:#eceaea;
  z-index:10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
`;

class CohortDetail extends Component {
  constructor(props) {
    super(props);
    const {
      companyState: {
        companies,
        companyCohorts
      },
      location: {
        state
      },
      match: {
        params: {
          cid,
          uid
        }
      }
    } = props;

    const thisCompany = state && state.company
      ? state.company
      : companies.find(item => item.id === parseInt(uid));

    const thisCohort = state && state.cohort
      ? state.cohort
      : companyCohorts[uid] && companyCohorts[uid].find(item => item.id === parseInt(cid));

    this.state = {
      cohort: thisCohort,
      company: thisCompany,
    };
  }

  setStartDate = (value) => {
    const { setFieldValue } = this.props;
    const date = dayjs(value).format('YYYY-MM-DD');
    setFieldValue('start_date', date, true);
  }

  openDatepicker = () => this._calendar.setOpen(true);

  render() {
    const {
      companyCohortUpdating,
      handleChange,
      handleSubmit,
      programs,
      trainers,
      values,
    } = this.props;

    return (
      <FormStyled onSubmit={handleSubmit}>
        <TextFieldStyled
          id='name'
          label='Cohort Name'
          name='name'
          onChange={handleChange}
          value={values.name}
        />
        <FormControlStyled>
          <InputLabel htmlFor='trainer-id'>Trainer</InputLabel>
          <Select
            value={values.trainer}
            onChange={handleChange}
            inputProps={{
              id: 'trainer-id',
              name: 'trainer'
            }}
          >
            {trainers.map((item, index) => {
              return <MenuItem key={`trainer-${item.user_id}-${index}`} value={item.user_id}>{item.name}</MenuItem>
            })}
          </Select>
        </FormControlStyled>
        <FormControlStyled>
          <InputLabel htmlFor='program-id'>Program</InputLabel>
          <Select
            value={values.program_id}
            onChange={handleChange}
            inputProps={{
              id: 'program-id',
              name: 'program_id'
            }}
          >
            {programs.map((item, index) => {
              return <MenuItem key={`program-${item.id}-${index}`} value={item.id}>{item.name}</MenuItem>
            })}
          </Select>
        </FormControlStyled>
       <FormControlStyled>
          <TextFieldStyled
                  id="date"
                  type="date"
                  value={values.start_date || ''}
                  inputProps={{ 
                    name: 'start_date', 
                    id: 'start_date', 
                    min: 'yyyy-MM-dd' // set the desired date format
                  }}
                  label="Start Date"
                  onChange={(e) => this.setStartDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
        </FormControlStyled>

        <ButtonContainer>
          <Button color='primary' variant='contained' type='submit'>Update Cohort</Button>
        </ButtonContainer>
        { companyCohortUpdating && <FormOverlay /> }
      </FormStyled>
    )
  }
}

CohortDetail.propTypes = {
};

CohortDetail.defaultProps = {
};

function mapStateToProps(state) {
  return {
    companyState: state.companyState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch)
}


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values);
    setSubmitting(false);
  },
  displayName: 'CohortDetailForm',
}))(CohortDetail);
